import { render, staticRenderFns } from "./UserTypeManage.vue?vue&type=template&id=3c9bc9d4&scoped=true&"
import script from "./UserTypeManage.vue?vue&type=script&lang=js&"
export * from "./UserTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeManage.vue?vue&type=style&index=0&id=3c9bc9d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9bc9d4",
  null
  
)

export default component.exports